import contractTransformations from "./contractTransformations";
import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractLitigationCaseTransformations from "./abstractLitigationCaseTransformations";

const rentalContractTransformations: FormTransformations = {
  dateFields: [
    { path: "rentalContractStartDate", type: "date" },
    { path: "rentalContractEndDate", type: "date" },
    ...contractTransformations.dateFields!,
  ],
  numberFields: abstractLitigationCaseTransformations.numberFields,
  timeFields: contractTransformations.timeFields,
  floatFields: [
    "previousBasicRent",
    "previousRentIncludingHeating",
    "futureBasicRent",
    "futureRentIncludingHeating",
    "depositAmount",
    "rentReductionPercentage",
    ...contractTransformations.floatFields!,
  ],
  ibanFields: contractTransformations.ibanFields,
  entityIriFields: contractTransformations.entityIriFields,
};
export default rentalContractTransformations;
